import React from 'react';
import { useParams, Link } from 'react-router-dom';

// Custom hooks
import useToolData from '../hooks/useToolData';

// Common components
import HtmlContent from '../components/common/HtmlContent';
import ToolsTable from '../components/tools/ToolsTable';

/**
 * CategoryPage Component
 * 
 * Exactly matches the legacy site's category page structure
 */
const CategoryPage = () => {
  const { category, subcategory } = useParams();
  const { data: categoryData, loading, error } = useToolData('category', category, subcategory);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error || !categoryData) {
    return <div className="not-found">Category not found</div>;
  }

  return (
    <main className="case-study">
      <span className="case-tool-title" id={category}>&nbsp;&nbsp;</span>
      <div className="linebreak"></div>
      <div className="tool-title-wrap">
        <div className="tool-title-icon"><i className="fas fa-tools fa-2x"></i></div>
        <div className="tool-title" id={category}>
          <span className="tool-title-number">
            <Link to={`/${category}`}>{categoryData.title}</Link>
          </span>
        </div>
        <div className="tool-title-nav">
          <Link to="/">R&D Toolkit</Link>&nbsp;&nbsp;
          <i className="fas fa-angle-double-right"></i>&nbsp;&nbsp;
          <Link to={`/research`}>Research</Link>
        </div>
        <div className="tool-title-link">
          <Link to={`/${category}`}><i className="fas fa-link fa-2x"></i></Link>
        </div>
      </div>

      <div className="linebreak"></div>

      <div id="tool-box-styling-grandparent" className="tool-box-styling">
        <div className="tool-opening-container">
          <div className="tool-opening">
            <HtmlContent 
              html={categoryData.intro} 
              containerClass=""
            />
          </div>
        </div>
      </div>

      <div id="tabs-grandparent" className="tabs">
        {categoryData.subcategories && categoryData.subcategories.map((subcategory, index) => (
          <React.Fragment key={subcategory.slug}>
            <input 
              type="radio" 
              name={`tabs-${category}`} 
              id={`tab-${category}-${subcategory.slug}`}
              checked={index === 0 ? "checked" : undefined}
            />
            <label htmlFor={`tab-${category}-${subcategory.slug}`}>{subcategory.title}</label>
            
            <div id="tab-no-sideborder" className="tab tab-tools">
              <ToolsTable 
                tools={subcategory.tools} 
                categorySlug={category} 
                subcategorySlug={subcategory.slug} 
              />
            </div>
          </React.Fragment>
        ))}
      </div>
    </main>
  );
};

export default CategoryPage; 